import React from "react"
import PropTypes from "prop-types"

const NotificationsIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 19 20">
    <path d="M11.1279012,17.1428571 L12.9537778,17.1428571 C12.6347654,18.7828571 11.2160988,20 9.50093827,20 C7.78577778,20 6.36711111,18.7828571 6.04809877,17.1428571 L7.87397531,17.1428571 C8.13669136,17.7904762 8.76345679,18.247619 9.50093827,18.247619 C10.2365432,18.247619 10.8633086,17.7904762 11.1279012,17.1428571 Z M16.7143704,13.9295238 C15.4814815,12.5104762 13.2934321,9.43047619 12.9969383,5.32380952 L12.788642,2.36571429 C12.2275556,2.13142857 11.0941235,1.75238095 9.5891358,1.75238095 L9.45590123,1.75238095 C7.96217284,1.75238095 6.82874074,2.13142857 6.26765432,2.36571429 L6.05935802,5.32380952 C5.7628642,9.43047619 3.5522963,12.4990476 2.29876543,13.9295238 L16.7143704,13.9295238 Z M19,15.7142857 L0,15.7142857 L0,13.727619 L0.29837037,13.4590476 C0.330271605,13.4380952 3.95950617,10.0780952 4.29916049,5.2 L4.5862716,1.28380952 L4.98222222,1.04952381 C5.04790123,1.00380952 6.77432099,0 9.45590123,0 L9.5891358,0 C12.270716,0 13.9971358,1.00380952 14.0740741,1.04952381 L14.4700247,1.28380952 L14.7571358,5.2 C15.1080494,10.0895238 18.6809877,13.4380952 18.7147654,13.4704762 L19,13.7390476 L19,15.7142857 Z"></path>
  </svg>
)

NotificationsIcon.propTypes = {
  style: PropTypes.object
}

export default NotificationsIcon



// WEBPACK FOOTER //
// ./src/components/icons/notifications-icon.jsx